<template>
    <div class="container mainContainer clearfix padding0">

            <div :id="sidebar_id" class="sideMenuComponent clearfix padding0"
                 :style="`width: ${intDefMenuWidth}px; z-index: 0; padding-right: inherit;`"
                 :class="`${addClass} col-${left}`">
                <div class="shadowLine" style="opacity: 0;"></div>
                <nav id="side-menu">
                    <div class="sideMenuHeader" v-on:click="handleHeaderClick"><i class="fa fa-bars"></i>{{lang('toggle_menu')}}
                    </div>
                    <ul class="nav" v-for="(parent, key) in tabsToRender" :index="key" :id="parent.tab_id" :key="`${key}_${parent.tab_id}`"
                        :class="{closedEl : parent.is_open, activeNav: parent.is_active}">
                        <li class="sideThinHeaderMenu" v-on:click="handleParentClick(key, parent.tab_id)">
                            <i :class="`${parent.icon} mediumIcon`"></i>{{getLabel(parent)}}
                        </li>
                        <router-link
                                v-for="(child, child_key) in parent.subitems"
                                :to="routerPath(child)"
                                :title="child.title"
                                :active-class="'active'" tag="li"
                                :id="getChildID(child, child_key)"
                                :key="child_key"
                                :class="{nav_slide_up : !parent.is_open}">
                                <a v-on:click.native="handleChildClick($event, parent.tab_id, child.tab_id)" relative><span>{{getLabel(child)}}</span></a>
                        </router-link>
                    </ul>
                    <!--<div class="sideMenuHeader" v-if="!!settingsConfig" v-on:click="handleFooterClick">-->
                        <!--<router-link-->
                                <!--:to="routerPath(tabsToRender[''])"-->
                                <!--:title="child.title"-->
                                <!--:active-class="'active'" tag="li"-->
                                <!--id="settings"-->
                                <!--key="settings"-->
                                <!--:class="{nav_slide_up : !parent.is_open}">-->
                            <!--<a v-on:click.native="handleChildClick($event, parent.tab_id, child.tab_id)" relative><span><i-->
                                    <!--class="fa fa-cogs"></i>{{lang('settings')}} </span></a>-->
                        <!--</router-link>-->
                    <!--</div>-->
                </nav>
            </div>
            <div :id="`${sidebar_id}_content`" :class="`col-${right}`"
                 style="padding: 0px">
                <slot :name="slotName"></slot>
            </div>

    </div>
</template>

<script>
    import {SideBar} from '../../entities/sidebar_class'

    export default {
        name: "np-router-sidebar",
        props: {
            sidebar_id: '',
            tabsConfig: {
                type: Array,
                note: 'List of tabs that will be rendered'
            },
            appendUrl: {
                default: ''
            },
            addClass: {
                default: ''
            },
            iconWidth: {default: 37},
            is_toggling: {default: false}, //icon_only feature
            split: {
                default: 0.166667 // determines width of maintabs and buttons
            },
            realpath: {
                type: Boolean,
                default: false,
                note: 'Tells what kind of links to look for in setting Active content, real links or #strings'
            },
            exact: {
                type: Boolean,
                default: false
            },
            slotName: {
                type: String,
            },
            rowFull: {
                type: Boolean,
                default: true,
                note: 'add row to starting div. If nesting a second sidebar, pass row-full as false'
            },
            vueRouter: {
                default: true,
                note: 'defines if vue-router is used on page'
            }
        },
        data: function () {
            return {
                level_2: false,
                tab_data: [],
                url_configs: [],
                settings_config : {},
                intDefMenuWidth: 200,
                intDefMenuMarginTop: -14,
                open_menu: true,
            }
        },
        mounted: function () {
            this.tab_data = this.tabsConfig;
            this.setActiveContent();

            let vm = this;
            $(function () {
                let targetWidth = vm.type === 'icon_only' ? vm.iconWidth : 200;

                let objID = '#' + vm.sidebar_id;
                $(objID + '_content').css({
                    width: 'calc(100% - ' + targetWidth + 'px)',
                    "padding-left": "inherit",
                    "padding-right": "inherit",
                    "z-index": "4",
                })

            })
        },
        computed: {
            urls: function () {
                return window.location.pathname;
            },
            tabsToRender: function () {
                let tabs = [];
                let vm = this;
                if (this.tab_data.length > 0) {
                    this.tab_data.forEach(function (obj, index) {
                        tabs.push(new SideBar(obj));
                        if (!!obj.subitems && obj.subitems.length > 0) {
                            vm.url_configs = obj.subitems;
                            vm.level_2 = true
                        }
                    })
                }
                return tabs;
            },
            settingsConfig: function() {
                let found = false;
                this.url_configs.forEach((obj) => {
                    if(obj.tab_id === 'settings') {
                        obj.is_active = true;
                        found = obj;
                    }
                });
                return found;
            },
            activeMain: function () {
                return this.tabsToRender.find(obj => {
                    return !!obj.is_active
                });
            },
            activeMainIndex: function () {
                return this.tabsToRender.findIndex(obj => {
                    return !!obj.is_active
                });
            },
            _split: function () {
                if (isNaN(this.split)) {
                    return 0.6;
                } else {
                    return this.split;
                }
            },
            left: function () {
                return Math.round(12 * this._split)
            },
            right: function () {
                return 12 - this.left;
            },
        },
        methods: {
            routerPath: function (tab) {
                // let path = !!tab.url ? tab.url : '#';
                let path = !!tab.url_router ? tab.url_router : '#';
                return {path: path}
            },
            setActiveContent: function (link = '') {
                let vm = this, tabs = [], is_active = false;

                if (vm.tabsConfig.length > 0) {
                    vm.tabsConfig.forEach((obj, index) => {
                        obj = new SideBar(obj);
                        obj.is_active = false;
                        if (vm.isActiveTab(obj, link)) {
                            obj.is_active = true;
                        }
                        if (!!obj.subitems && obj.subitems.length > 0) {
                            let sub_tabs = [];
                            obj.subitems.forEach((sub) => {
                                sub.is_active = false;
                                if (vm.isActiveTab(sub, link)) {
                                    obj.is_active = true;
                                    obj.is_open = true;
                                    sub.is_active = true;
                                }
                                sub_tabs.push(sub)
                            });
                            obj.subitems = sub_tabs
                        }
                        // if ((index + 1 === vm.tabsConfig.length) && is_active === false) { //on first load and no url matches, set first tab to active.
                        //     vm.tabsConfig[0].is_active = true;
                        //     vm.tabsConfig[0].is_open = true;
                        //     if (vm.tabsConfig[0].hasOwnProperty('subitems') && vm.tabsConfig[0].subitems.length > 0) {
                        //         vm.tabsConfig[0].subitems[0].is_active = true;
                        //     }
                        //
                        //     is_active = true;
                        // }
                        tabs.push(obj);
                    })
                    vm.tab_data = tabs;
                }
            },
            isActiveTab: function (tab, link = '') {
                if (link === '') {
                    link = !!tab.url_router && tab.url_router !== '' && tab.url_router !== '#' ? tab.url_router : '#';
                }
                let reflink = window.location.href.split('#')[0];
                return !!reflink.match(link); //this prevents matching # to 'jskjddskjds#'
            },
            handleHeaderClick: function () {
                let vm = this;

                vm.tab_data.forEach(obj => { //closes all open tabs
                    obj.is_open = false;
                })

                vm.toggleMenu();

                this.$emit('headerclick', vm.sidebar_id);
            },
            toggleMenu: function () {
                let vm = this,
                    objID = '#' + vm.sidebar_id,
                    targetWidth = 33,
                    objMenuBlock = $(objID + '.sideMenuComponent'),
                    slotContentBlock = $(objID + '_content'),
                    animation_time = 400,
                    objContentContainerWidth = $(objID).parent().innerWidth();

                if (vm.open_menu) {
                    let contentTargetWidth = objContentContainerWidth - (targetWidth);
                    //close side menu
                    objMenuBlock.animate({
                        width: targetWidth + 'px'
                    }, animation_time);

                    slotContentBlock.css({
                        width: contentTargetWidth + 'px'
                    })
                    //expand content area
                    // slotContentBlock.animate({
                    //     width: contentTargetWidth + 'px'
                    // }, animation_time);
                    objMenuBlock.addClass('closed');
                    vm.open_menu = false;
                } else {
                    // recalculate width based on values, employ split and left and right works unless you change the viewport size i.e open console
                    let left_percent = vm._split,
                        desiredWidth = objContentContainerWidth * left_percent,
                        resetMenuWidth = desiredWidth < 200 ? desiredWidth : 200, //never grow larger than 200
                        resetSlotContentWidth = objContentContainerWidth - (resetMenuWidth);


                    //TODO figure out how to do percentage calculation to fit a second toggle menu
                    //  reset Menu
                    objMenuBlock.animate({
                        width: resetMenuWidth + 'px'
                    }, animation_time);

                    slotContentBlock.css({
                        width: resetSlotContentWidth + 'px'
                    })
                    //reset slot content
                    // slotContentBlock.animate({
                    //     width: resetSlotContentWidth + 'px'
                    // }, animation_time);

                    objMenuBlock.removeClass('closed')
                    vm.open_menu = true;
                }
            },
            handleParentClick: function (key, parent_tab_id = '') {
                let vm = this;
                let tab_link = '';

                if (!vm.open_menu) {
                    vm.toggleMenu();
                }

                vm.tabsConfig.find((obj) => {
                    if(obj.tab_id === parent_tab_id) {
                        tab_link = obj.url_router;
                        obj.is_open = true;
                    } else {
                        obj.is_open = false;
                    }
                });

                vm.setActiveContent(tab_link);

                // EventBus.$emit('parentmenuclick', this.sidebar_id, parent_tab_id);
                this.$emit('parentmenuclick', parent_tab_id) //not being registered in vue-router
            },
            handleChildClick: function (event, parent_tab_id, child_tab_id) {
                vm.tabsConfig.forEach((obj, index) => {
                    if(obj.tab_id === parent_tab_id) {
                        obj.is_active = true;
                    }
                });
                this.$emit('childmenuclick', parent_tab_id, child_tab_id)
                // this.setActiveContent();
                // EventBus.$emit('childmenuclick', this.sidebar_id, parent_tab_id, child_tab_id);

            },
            handleFooterClick: function (event, parent_tab_id, child_tab_id) {
                vm.tabsConfig.forEach((obj, index) => {
                    obj.is_active = true;
                    if (obj.tab_id === parent_tab_id) {
                    }
                });
                this.$emit('footermenuclick', parent_tab_id, child_tab_id)
            },
            getChildUrl: function (subtab) {
                return subtab.hasOwnProperty('url_router') && subtab.url_router !== '' ? subtab.url_router : '#';
            },
            getParentUrl: function (tab) {
                return tab.hasOwnProperty('url_router') && tab.url_router !== '' ? tab.url_router : '#';
            },
            getChildID: function (child, key) {
                return child.tab_id + '_' + key;
            },
            getLabel: function (tab) {
                return tab.lang_key !== '' ? this.lang(tab.lang_key) : tab.label
            },
        },
        watch: {
            tabsConfig: {
                handler: function (newValue) {
                    this.tab_data = newValue;
                },
                deep: true
            },
            urls: function () {
                this.setActiveContent();
            }
        },
    }
</script>

<style scoped>
    .sideMenuComponent {
        position: relative;
        border-right: 2px solid;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        /*top: 4px;*/
        /*margin-top: -10px;*!*/
        /* margin-bottom: -1px; */
        /*left: -15px;*/
        background: #f8f8f8;
        border-right-color: #b2c6d0;
        min-height: 500px;
        /* width: 0;*/
    }

    .sideMenuComponent.closed .sideThinHeaderMenu {
        padding-left: 0px;
    }

    #side-menu li.sideThinHeaderMenu {
        z-index: 1;
    }

    #side-menu a:not(.sideThinHeaderMenuLink):not(.sideDeepHeaderMenuLink):not(.sideDeepHeaderSubMenuLink):not(.sideDeepLastLink) {
        z-index: 1;
    }

    .sideThinHeaderMenu i {
        background-color: white;
        color: #003F51;
    }

    .activeNav .sideThinHeaderMenu i {
        background-color: #003F51;
        color: white;
    }

    /*.sideMenuComponent div.sideMenuHeader:focus{*/
    /*    transition-duration: 0.5s;*/
    /*    transition-timing-function: ease-in;*/
    /*    transition-delay: 0.3s;*/
    /*}*/
    .sideMenuComponent .closed {
        width: 33px;
        transition: left 2s;
    }
    .container.mainContainer {
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: stretch;
        -moz-align-items: stretch;
        -ms-flex-line-pack: stretch;
        align-items: stretch;
    }
    .container.mainContainer .sideMenuComponent {
        -webkit-flex: 0 1 auto;
        -moz-flex: 0 1 auto;
        -ms-flex: 0 1 auto;
        flex: 0 1 auto;
        /* flex-grow flex-shrink, flex-basis */
        /*-webkit-transition: all 0.4s ease-in-out;*/
        /*-moz-transition: all 0.4s ease-in-out;*/
        /*transition: all 0.4s ease-in-out;*/
    }
    .container.mainContainer .contentOuter {
        -webkit-flex: 1 1 80%;
        -moz-flex: 1 1 80%;
        -ms-flex: 1 1 80%;
        flex: 1 1 80%;
    }
</style>
